import service from '../service.js'

export default {
    /**
     * 获取项目列表
     * @returns 
     */
    List: () => {
        return service({
            url: '/ProjectRecord/List',
            method: 'get',
        })
    },
}